import { getLocalAuthStorage } from 'utils/localStorage';

const addBearerTokenInReq = config => {
  const storage = getLocalAuthStorage();
  const token = storage?.token;
  config.headers.Authorization = token ? `Bearer ${token}` : '';
  return config;
};

export { addBearerTokenInReq };
